'use client'

import {useTranslate} from '@local/hooks'
import {PrivateRetreatSlideout} from './PrivateRetreatSlideout'
import {Button, Calendly, EnquireForm} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import {useState} from 'react'

interface Props {
	className?: string;
	withPrivateRetreat: boolean;
	contactForm: {
		listID: string;
		successText: string;
		description: string;
		successTitle: string;
		retreatList: Array<{ label: string; id: string; value: string }>;
	};
	organizeRetreatQuestions: {
		listID: string;
		successText: string;
		successTitle: string;
		tripLengths: Array<string>;
		guestCounts: Array<string>;
		priceRanges: Array<string>;
		tripCategories: Array<string>;
		howDidYouHearQuestions: Array<string>;
	};
}

export const FormSlideout = ({
	className,
	withPrivateRetreat,
	contactForm,
	organizeRetreatQuestions,
}: Props) => {
	const locale = useTranslate()
	const [isPrivateOpen, setIsPrivateOpen] = useState<boolean>(false)
	const [isContactOpen, setIsContactOpen] = useState<boolean>(false)
	const [isCalendlyOpen, setIsCalendlyOpen] = useState<boolean>(false)
	return (
		<>
			<div
				className={cx(
					'mx-auto flex flex-col lg:flex-row justify-center gap-10 lg:gutter-gap-1 lg:pb-70',
					className,
				)}>
				{withPrivateRetreat && (
					<Button
						small
						className='w-full lg:span-w-3'
						variant='secondary-transparent'
						onClick={() => setIsPrivateOpen(true)}
						border>
						{locale('Start Planning')}
					</Button>
				)}
				{/* <Button
					small
					className='w-full lg:span-w-3'
					onClick={() => setIsContactOpen(true)}
					variant='primary'>
					{locale('Contact')}
				</Button> */}
				<Button
					small
					border
					variant='primary'
					className='w-full lg:span-w-3'
					onClick={() => setIsCalendlyOpen(true)}>
					{locale('Schedule a Call')}

				</Button>
			</div>

			{organizeRetreatQuestions && withPrivateRetreat && (
				<PrivateRetreatSlideout
					{...organizeRetreatQuestions}
					isOpen={isPrivateOpen}
					onClickClose={() => setIsPrivateOpen(false)} />
			)}
			{contactForm && (
				<EnquireForm
					title='Register'
					{...contactForm}
					isOpen={isContactOpen}
					onClickClose={() => setIsContactOpen(false)} />
			)}
			<Calendly
				isOpen={isCalendlyOpen}
				onClose={() => setIsCalendlyOpen(false)} />
		</>
	)
}
